import { useSelectedOrgUnit } from '@retail/app/stores/selected-context';
import { useCentralAssortmentFilters } from '@retail/my-assortment/context';
import { useFetchCentralAssortmentMemberViewFilterOptions } from '@retail/my-assortment/data-access';

interface Props {
  suspense?: boolean;
}

export function useCentralAssortmentMemberViewFilterOptions({ suspense = true }: Props = {}) {
  const { assortmentId } = useSelectedOrgUnit();

  const { data: filterOptions } = useFetchCentralAssortmentMemberViewFilterOptions({
    assortmentId,
    suspense,
  });

  return useCentralAssortmentFilters(filterOptions);
}
